import { useRef, useState, useEffect } from 'react';

// will re-render whenever the supplied Atom value changes
export default function useValue(atom) {
  const ref = useRef(null);

  const [val, updateState] = useState(() => (
    atom.snapshot()
  ));
  
  useEffect(() => {
    ref.current?.();
    ref.current = atom.subscribe(val => {
      updateState(val);
    });

    if (val !== atom.snapshot()) {
      updateState(atom.snapshot());
    }

    return () => {
      ref.current?.();
      ref.current = null;
    };
  }, [atom, updateState]);

  return atom.snapshot();
};